var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "water-panel-body" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "water-panel-contents" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "water-amount" },
          [
            _vm._l(_vm.teaCups, function(teaCup, index) {
              return _c("img", {
                staticClass: "tea-drink",
                attrs: { src: teaCup.img, id: index },
                on: {
                  click: function($event) {
                    return _vm.pushedTeaDrink(index + 1)
                  }
                }
              })
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "hand-tea-drink",
              attrs: {
                src: require("@/assets/meal_entry/アセット 29@2x.png"),
                width: "335",
                height: "457",
                loading: "lazy"
              }
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "attention" }, [
          _vm._v("\n        ※1日の摂取目標は1000mlです\n      ")
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "complete",
          attrs: {
            src: require("@/assets/meal_entry/アセット 8@2x.png"),
            width: "906",
            height: "336"
          },
          on: { click: _vm.pushedDone }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "water-panel-img" }, [
      _c("img", {
        staticClass: "hand-tea-drink",
        attrs: {
          src: require("@/assets/meal_entry/アセット 41@2x.png"),
          width: "2262",
          height: "3116",
          loading: "lazy"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "water-question" }, [
      _c("p", { staticClass: "main-text" }, [
        _vm._v("今日何杯飲みましたか？"),
        _c("br"),
        _c("span", { staticClass: "sub-text" }, [
          _vm._v("（アルコール類は含まない）")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14706558", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14706558","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/molecules/InputWaterIntake.vue
// module id = null
// module chunks = 